import React, { useCallback, useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  TextField,
  MenuItem,
  ListItemText,
  InputAdornment,
  Radio,
  FormControlLabel,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  debounce,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../formElements/InputField";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import { API, graphqlOperation } from "aws-amplify";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import { useDispatch, useSelector } from "react-redux";
import {
  createAccountGSTDetails,
  updateAccountMaster,
  updateAccountGSTDetails,
} from "../../graphql";
import {
  getAccountGSTDetails,
  searchHSN,
} from "../../graphql";
import AddPartyModal from "./AddPartyModal";
import AddBankAccount from "./AddBankAccount";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import AddHSNModal from "../../pages/PrimeFigma/Modals/AddHSNModal";
import { grey } from "@mui/material/colors";
import { AddBox } from "@mui/icons-material";
import { useThemes } from "../Theme/theme";
import { CustomListAccountMasterSearch } from "../../graphql/customQueries";
import { useDebounce } from "../../hooks/useDebounce";
import { listAccountMasterv2Api } from "../../redux/apis/accountMaster.api";
import { useListGroupMasterQuery } from "../../redux/apis/accountGroupMaster.api";
import AddNewPartyModal from "../../pages/PrimeFigma/Modals/AddNewPartyModal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  width:{xs:"90%", sm:"500px"}
};

const EditToAccount = ({
  open,
  setOpen,
  setsuccessSnakbar,
  setSnakbarText,
  setWarningSnakbar,
  setWarningText,
  setState1,
  msg,
  itemEntry,
  setNewAccID,
  purchaseAccDetails,
  disableAll,
  disable,
  passFn,
  setUpdateModal,
  setSelectedRow,
  setHeadForLedger,
  selectedPath,
  setNewPartyId,
  setNewId,
  setDisablePopup
}) => {

  const { theme } = useThemes()

  const [backdropOpen, setBackdropOpen] = useState(false);

  const [group, setGroup] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [openBankModal, setOpenBakModal] = useState(false);
  const [partyName, setPartyName] = useState("");
  const [partyType, setPartyType] = useState("");
  const [accName, setAccName] = useState("");
  const [filterHSN, setFilterHSN] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [newPath, setnewPath] = useState(null)
  const [state, setState] = useState({
    group: { label: "", value: "", accountTypeCD: "" },
    name: "",
    hsnCode: { label: "", value: "" },
    HSN: "",
    gstrate: "",
    cess: "",
    cessType: "",
    displayOrderNo: "",
    accountsID: "",
    enteredTimeStamp: 0,
    effectivedate: 0,
    expireddate: 0,
    errorStatus: {
      group: false,
      name: false,
      hsnCode: false,
      gstrate: false,
      cess: false,
      cessType: false,
    },
    errorFields: {
      group: "",
      name: "",
      hsnCode: "",
      cess: "",
      cessType: "",
      gstrate: "",
    },
  });
  useEffect(() => {
    if (state.HSN !== "") {
      setState((prev) => ({
        ...prev,
        hsnCode: {
          label: state.HSN.label,
          value: state.HSN.value,
        },
      }));
    }
  }, [state]);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "s") {

        console.log("===>inside function")
        e.preventDefault();
        saveChanges()
      }
    };
  
    window.addEventListener('keydown', controlAndS);
  
    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, [state])

  
  let dispatch = useDispatch()
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState("");
  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      value = value
        ?.toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: true,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: name + " is Required",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: false,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: "",
        },
      }));
    }
  };

  const { data: groupData, isloading, iserror } = useListGroupMasterQuery()

  function createKey(obj) {
    const newOption = {
      label: obj?.accountgroupname,
      value: obj?.accountgroupid,
      accountTypeCD: obj?.accounttypecd,
      path: obj?.path
    };

    setGroup((prevOptions) => [...prevOptions, newOption]);
  }
  let companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );


  console.log("companyDetails", companyDetails)



  async function searchSAC(value, limit) {
    if ((typeof value) == "object") {
      value = ""
    }
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, {
          rowfrom: 0,
          limitno: limit !== undefined ? limit : 10000,
          word: value,
        })
      );
      if (res.data.searchHSN !== null) {
        let arr = [{ label: "", value: "" }];
        res.data.searchHSN?.map((item) => {
          arr.push({
            label: `${item.hsnsaccode} - ${item.description}`,
            value: `${item.hsnsaccode}`,
          });
        });
        arr = arr.filter((e) => e.label !== "");
        let hsnValue = state.hsnCode || []
        const uniqueArray = [
          ...[hsnValue, ...arr].reduce((map, item) => {
            if (!map.has(item.value)) {
              map.set(item.value, item);
            }
            return map;
          }, new Map()).values()
        ];
        setFilterHSN(uniqueArray);
      }
    } catch (error) {
      console.log(error);
    }
  }
  const handleSearch = useCallback(
    debounce((searchValue) => {
      searchSAC(searchValue);
    }, 500),
    []
  );
  async function searchSACItem(value) {
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, { rowfrom: 0, limitno: 10000, word: value })
      );
      let hsnObj = { label: "", value: "" };
      let arr = [];
      if (value === 0) {
        arr.push({
          label: value,
          value: value,
        });
      }
      if (res.data.searchHSN !== null) {
        await Promise.all(
          res.data.searchHSN.map((item) => {
            arr.push({
              label: `${item.hsnsaccode} - ${item.description}`,
              value: `${item.hsnsaccode}`,
            });
            if (Number(item.hsnsaccode) === Number(value)) {
              hsnObj = {
                label: `${item.hsnsaccode} - ${item.description}`,
                value: `${item.hsnsaccode}`,
              };
            }
          })
        );
      }
      if (hsnObj.label === "" && value !== 0) {
        hsnObj = {
          label: value,
          value: value,
        };
      }
      setFilterHSN((prev) => [...prev, arr]);
      return { hsnObj, arr };
    } catch (error) {
      console.log(error);
    }
  }


  async function editAccountGstDetails(accID) {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(
        graphqlOperation(getAccountGSTDetails, { accountid: accID })
      );
      if (res.data.getAccountGSTDetails != null) {
        let hsnCode = {};
        let hsnobj254 = {};
        const gstDetails = res.data.getAccountGSTDetails?.[0]
        if (gstDetails.hsnid !== 0) {
          hsnobj254 = await searchSACItem(gstDetails.hsnid);
        }
        hsnCode = hsnobj254?.hsnObj;
        setState((prev) => ({
          ...prev,
          hsnCode: hsnCode,
          gstrate: gstDetails.gstrate,
          cessType: gstDetails.gstcompensationtype,
          cess: gstDetails.cessamount,
          enteredTimeStamp: gstDetails?.enteredtimestamp,
          effectivedate: gstDetails?.effectivedate,
          expireddate: gstDetails?.expireddate,
        }));
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setBackdropOpen(false);
    }
  }




  const [suggestions, setsuggestions] = useState([]);
  const fetchLedgers = useCallback(
    useDebounce(async (value) => {
      try {
        let res = await API.graphql(
          graphqlOperation(CustomListAccountMasterSearch, { Word: value })
        );
        setsuggestions((prev) => [
          ...res.data.listAccountMasterSearch.map((elem) => {
            // return elem?.AccountName?.toLocaleLowerCase()
            return {
              label:
                elem?.AccountName?.toLocaleLowerCase() +
                elem?.AccountGroupName?.toLowerCase(),
              ledger: elem?.AccountName,
              group: elem?.AccountGroupName,
            };
          }),
        ]);
      } catch (error) {
        console.log(error);
      }
    }, 500),
    []
  );

  useEffect(() => {
    if (open) {
      editAccountGstDetails(purchaseAccDetails?.accountsID);
      let groupArray = groupData || []
      let GSTArrayValues = [31, 32, 33]
      let setArrayAll = companyDetails?.relatedcompanydetailsnew?.[0].registrationtype !== 1 ? [...groupArray] : groupArray.filter((e) => !GSTArrayValues.includes(e.accountgroupid))
      setArrayAll?.sort((a, b) => a.accountgroupname.localeCompare(b.accountgroupname))
      if (!disableAll) {
        if (setArrayAll) {
          setArrayAll?.map((obj) => {
            createKey(obj);
          });
        }
        if (filterHSN.length < 10) {
          searchSAC(0, 10);
        }
      }
      setState((prev) => ({
        ...prev,
        group: {
          label: purchaseAccDetails?.group?.label,
          value: purchaseAccDetails?.group?.value,
          accountTypeCD: purchaseAccDetails?.group?.accountTypeCD,
        },
        // name: purchaseAccDetails?.name !== undefined ? purchaseAccDetails?.name : accountName,
        name: purchaseAccDetails?.name,
        hsnCode: {
          label: purchaseAccDetails?.hsnCode?.label,
          value: purchaseAccDetails?.hsnCode?.value,
        },
        cess:
          purchaseAccDetails?.cess === undefined
            ? ""
            : purchaseAccDetails?.cess,
        cessType: purchaseAccDetails?.cessType,
        gstrate: purchaseAccDetails?.gstrate,
        accountsID: purchaseAccDetails?.accountsID,
        // displayOrderNo: purchaseAccDetails?.displayOrderNo,
        // enteredTimeStamp: purchaseAccDetails?.enteredTimeStamp,
        errorStatus: {
          group: false,
          name: false,
          hsnCode: false,
          cess: false,
          cessType: false,
          gstrate: false,
        },
        errorFields: {
          group: "",
          name: "",
          hsnCode: "",
          cess: "",
          cessType: "",
          gstrate: "",
        },
      }));
    }
    return () => {
      setGroup([]);
    };
  }, [open]);

  const handleClose = (event, reason) => {
    setDisablePopup(false)
    if (reason !== "backdropClick") {
      setState((prev) => ({
        ...prev,
        group: { label: "", value: "", accountTypeCD: "" },
        name: "",
        hsnCode: { label: "", value: "" },
        cess: "",
        cessType: "",
        gstrate: "",
        errorStatus: {
          group: false,
          name: false,
          hsnCode: false,
          cess: false,
          cessType: false,
          gstrate: false,
        },
        errorFields: {
          group: "",
          name: "",
          hsnCode: "",
          cess: "",
          cessType: "",
          gstrate: "",
        },
      }));
      setLoading(false);
      setOpen(false);
    }

  };

  const isNameDuplicate = (list, nameKey, inputName, excludeValue) =>
    list?.some(item =>
      item?.[nameKey]?.toLowerCase()?.trim() === inputName?.toLowerCase()?.trim() &&
      item?.[nameKey] !== excludeValue
    );

  const normalizeString = str => str?.toLowerCase()?.trim() || '';

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((key) => {
      if (key === "name") {
        const normalizedName = normalizeString(state.name);
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Account Name is required";
          obj.errorStatus.name = true;
        } else {

          if (isNameDuplicate(ledger, "AccountName", normalizedName, purchaseAccDetails?.name)) {
            isvalid = false;
            obj.errorFields.name = "Account Name already exists";
            obj.errorStatus.name = true;
          }

          if (isNameDuplicate(groupData, "accountgroupname", normalizedName, purchaseAccDetails?.name)) {
            isvalid = false;
            obj.errorFields.name = "This name already exists in the group";
            obj.errorStatus.name = true;
          }

        }
      }

      if (key === "group") {
        if (data[key].value == 0) {
          isvalid = false;
          obj.errorFields.group = "Group is required";
          obj.errorStatus.group = true;
        } else {
          // isvalid=true;
          obj.errorFields.group = "";
          obj.errorStatus.group = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }
  async function saveNewAccounts(data) {
    try {
      const resledger = await API.graphql(
        graphqlOperation(updateAccountMaster, {
          updateAccountMasterInput: data,
        })
      );
      saveGstDetails(resledger?.data?.updateAccountMaster?.accountsid);
      if (resledger.data.updateAccountMaster.statuscode === "Error") {
        setLoading(false);
        showWarningSnackbar(
          resledger?.data?.updateAccountMaster?.statusmessage
        );
      } else {
        if (resledger.data.updateAccountMaster !== null) {
          setOpen(false);
          if (setNewAccID) {
            setNewAccID(resledger?.data?.updateAccountMaster?.accountsid);
          }

          if (msg === "Purchase") {
            if (itemEntry) {
              setState1((prev) => ({
                ...prev,
                purchaseAccount: {
                  label: resledger?.data?.updateAccountMaster?.accountname,
                  value: resledger?.data?.updateAccountMaster?.accountsid,
                },
              }));
            } else {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label: resledger?.data?.updateAccountMaster?.accountname,
                  value: resledger?.data?.updateAccountMaster?.accountsid,
                },
              }));
            }
          }

          showSuccessSnackbar("Account Updated Successfully");
          setNewPartyId("")
          setNewId("")
          dispatch(listAccountMasterv2Api.util.invalidateTags(["listAccountMaster"]))
          setLoading(false);
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            hsnCode: { label: "", value: "" },
            cess: "",
            cessType: "",
            gstrate: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: false,
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
          setLoading(false);
        }
      }
      if (passFn !== undefined) {
        passFn();
      }
    } catch (error) {
      // setSnakbarText("Account not Added");
      setLoading(false);
      console.log(error);
    }
  }

    function comparePathWithId(pathString, ...ids) {
    const pathArray = pathString?.replace(/^\/|\/$/g, "").split("/");
    return ids.some((id) => pathArray?.includes(id.toString()));
  }
  const [newPartyName,setNewPartyName ] = useState()
  const [selelctedGroupId,setSelectedGroupId] = useState()
  const [newPartyID,setNewPartyID] = useState()
  const [openPartyModal1,setOpenPartyModal1] = useState(false)


  async function saveGstDetails(accID) {
    try {
      // if (state?.enteredTimeStamp === 0) {
      //   const gstData = {
      //     AccountID: accID,
      //     EffectiveDate: Math.floor(new Date().getTime() / 1000),
      //     ExpiredDate: 0,
      //     GSTCompensationType: state.cessType,
      //     GSTRate: state.gstrate,
      //     HSNID: state.hsnCode.value == "" ? 0 : Number(state.hsnCode.value),
      //     CessAmount: state.cess == "" ? 0 : Number(state.cess),
      //   };
      //   const resGstData = await API.graphql(
      //     graphqlOperation(createAccountGSTDetails, {
      //       createAccountGSTDetailsInput: gstData,
      //     })
      //   );
      //   setBackdropOpen(false);
      // } else {
      const gstData = {
        accountid: accID,
        enteredtimestamp: state?.enteredTimeStamp,
        effectivedate: state?.effectivedate,
        expireddate: state?.expireddate,
        gstcompensationtype: state.cessType,
        gstrate: Number(state.gstrate),
        hsnid: parseInt(state.hsnCode.value),
        cessamount: state.cess == "" ? 0 : Number(state.cess),
      };
      const resGstData = await API.graphql(
        graphqlOperation(updateAccountGSTDetails, {
          updateAccountGSTDetailsInput: gstData,
        })
      );
      setBackdropOpen(false);
      // }
    } catch (error) {
      console.log(error);
      setBackdropOpen(false);
    }
  }




  async function saveChanges() {
    const {
      group,
      name,
      hsnCode,
      cess,
      cessType,
      gstrate,
      displayOrderNo,
      accountsID,
    } = state;
    const formData = {
      group,
      name,
      hsnCode,
      cess,
      cessType,
      gstrate,
    };


    if (formValidation(formData)) {
      setLoading(true);

      const LedgerData = {
        accountgroupid: group?.value,
        accountname: name,
        accounttypecd: group?.accountTypeCD,
        accountsid: accountsID,
        companybranchid: 0,
        hsnsaccode: state?.hsnCode?.value || 0,
        accounttypeflag: 0,
        is_active: 1,
      };

      saveNewAccounts(LedgerData);

    }
  }

  const righrSideValues = [ "18", "22", "24"]

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {disableAll ? `View` : `Edit`} Account
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: { xs: "5px", sm: "15px" },
                // height:{xs:"400px",sm:'auto'},
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <Autocomplete
                    id="autocomplete"
                    options={suggestions}
                    autoHighlight
                    sx={{
                      "& .MuiAutocomplete-popupIndicator": {
                        display: "none", // Hide the dropdown icon
                      },
                    }}
                    size="small"
                    // getOptionLabel={(option) => option?.label}
                    // defaultValue={suggestions[0]}
                    value={state.name}
                    onChange={(e, newValue) => {
                      if (e.target.value == undefined) {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          edit: { ...prev.edit, name: true },
                          errorFields: {
                            ...prev.errorFields,
                            name: "Account Name is required",
                          },
                          errorStatus: { ...prev.errorStatus, name: true },
                        }));
                      }
                    }}
                    classes={{
                      popper: "customPopperAutoCmpt",
                      paper: "customPaperAutoCmpt",
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        onClick={(e) => e.preventDefault()}
                        disabled
                      >
                        <b>
                          {" "}
                          {option?.ledger ?? (
                            <Typography
                              component={"span"}
                              sx={{ color: "error.main" }}
                            >
                              No Ledger
                            </Typography>
                          )}
                        </b>{" "}
                        <i>({option?.group})</i>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="name"
                        disabled={
                          (state?.group?.value !== ""
                            ? disableAll === undefined
                              ? true
                              : disableAll
                            : false) || purchaseAccDetails?.restrictedflag === 1
                            ? true
                            : false
                        }
                        required
                        onChange={(e) => {
                          const trimmedValue = e?.target?.value?.trim();
                          if (trimmedValue === "") {
                            setState((prev) => ({
                              ...prev,
                              name: trimmedValue,
                              edit: { ...prev.edit, name: true },
                              errorFields: {
                                ...prev.errorFields,
                                name: "Account Name is required",
                              },
                              errorStatus: { ...prev.errorStatus, name: true },
                            }));
                          } else {
                            fetchLedgers(trimmedValue);
                            let isvalid = true;

                            ledger.forEach((item) => {
                              if (
                                item.accountname.toLowerCase() ===
                                trimmedValue.toLowerCase()
                              ) {
                                isvalid = false;
                              }
                            });

                            if (!isvalid) {
                              setState((prev) => ({
                                ...prev,
                                name: trimmedValue,
                                errorFields: {
                                  ...prev.errorFields,
                                  name: "Account Name already exists",
                                },
                                errorStatus: {
                                  ...prev.errorStatus,
                                  name: true,
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                name: trimmedValue,
                                errorFields: { ...prev.errorFields, name: "" },
                                errorStatus: {
                                  ...prev.errorStatus,
                                  name: false,
                                },
                              }));
                            }
                          }
                        }}
                        onInput={(e) => {
                          if (e.target.value.length > 30) {
                            e.target.value = e.target.value.slice(0, 30);
                          }
                        }}
                        label="New Ledger Name"
                        variant="outlined"
                        onBlur={() => {
                          const trimmedName = state.name?.trim();
                          if (
                            suggestions.some((elem) =>
                              elem.label
                                ?.toLowerCase() == trimmedName?.toLowerCase()
                            )
                          ) {
                            setState((prev) => ({
                              ...prev,
                              name: prev.name?.replace(/\s+/g, ' ')?.trim(),
                              errorStatus: { ...prev.errorStatus, name: true },
                              errorFields: {
                                ...prev.errorFields,
                                name: "Account Name Required",
                              },
                            }));
                          }
                        }}
                        error={state.errorStatus.name}
                        sx={{
                          "& .MuiInputBase-root": { fontSize: "14px" },
                          "& .MuiInputLabel-root": {
                            fontSize: "14px",
                            color: "input.font",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          "& .MuiFormLabel-root.Mui-focused": {
                            color: "input.font",
                          },
                          ".MuiInputLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                      />
                    )}
                    PaperComponent={(props) => {
                      if (
                        state?.name?.length > 2 &&
                        suggestions.length > 0 &&
                        suggestions.some((elem) =>
                          elem.label.includes(state.name)
                        )
                      ) {
                        return (
                          <Paper {...props}>
                            <Typography
                              style={{
                                padding: "4px",
                                paddingLeft: "6px",
                                color: "red",
                              }}
                              component="div"
                            >
                              Existing Ledgers
                            </Typography>
                            {props.children}
                          </Paper>
                        );
                      }
                    }}
                  />

                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.name}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>

                  <Autocomplete
                    disabled={
                      (state?.group?.value !== ""
                        ? disableAll === undefined
                          ? true
                          : disableAll
                        : false) || purchaseAccDetails?.restrictedflag === 1
                        ? true
                        : false
                    }
                    disablePortal
                    autoHighlight
                    openOnFocus
                    options={group}
                    id="group"
                    disableClearable
                    getOptionLabel={(option) => option?.label}
                    // isOptionEqualToValue={(option, value) =>
                    //   option.value == value.value
                    // }
                    value={state.group}
                    onChange={(e, newValue) => {
                      const segments = newValue.path.split("/")
                      setnewPath(segments)
                      if (segments.includes("17") || segments.includes("29")) {
                        if (setSelectedRow) {
                          setSelectedRow((prev) => (
                            {
                              ...prev,
                              name: purchaseAccDetails.name,
                              category: "ledger",
                              defaultGroupId: segments.includes("17") ? "17" : "29",
                              create: "edit",
                              groupName: newValue?.label,
                              value:newValue.value,
                              accountsID:purchaseAccDetails.accountsID
                            }
                          ))
                        }
                        setOpen(false)
                        setHeadForLedger("Edit Ledger")
                        return setUpdateModal(true)
                      }
                      if (newValue === "") {
                        setState((prev) => ({
                          ...prev,
                          group: newValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            group: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            group: "Group  Field is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          group: newValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            group: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            group: "",
                          },
                        }));
                      }
                        if(comparePathWithId(newValue.path, 15)){                    
                          setSelectedGroupId(newValue.value);
                          setNewPartyName(state.name);
                          setOpenPartyModal1(true);
                          // setOpen(false);
                          // handleClose();
                        }
                        // if (newValue.value === 7) {
                          if(comparePathWithId(newValue.path, 7)){
                          setSelectedGroupId(newValue.value);
                          setNewPartyName(state.name);
                          setOpenPartyModal1(true);
                          // setOpen(false);
                          // handleClose();
                        }
                    }}
                    sx={{
                      ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                      {
                        paddingBottom: "5px",
                      },
                      ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                      {
                        paddingTop: "6px",
                        paddingBottom: "5px",
                        paddingLeft: "6px",
                      },
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        error={state.errorStatus.group === true ? true : false}
                        required={true}
                        label="Under Group"
                        sx={{
                          ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            padding: "8.5px 7px",
                          },
                          ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                          {
                            fontSize: "14px",
                          },
                          label: {
                            fontSize: "14px",
                          },
                          ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                            fontSize: "14px",
                          },
                          ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-14qz1ij-MuiListItemText-root": {
                            margin: "0px",
                          },
                          ".css-wgai2y-MuiFormLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                      />
                    )}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.group}
                  </Typography>
                </Box>
              </Box>
              { righrSideValues?.some(value => newPath? newPath.includes(value): selectedPath?.includes(value))&& companyDetails?.relatedcompanydetailsnew?.[0]
                ?.registrationtype !== 1 && (
                  <Accordion sx={{ mt: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ maxHeight: "auto" }}
                    >
                      <Typography
                        sx={{ color: "primary.main", fontWeight: "500" }}
                      >
                        GST Details
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ display: "flex", flexDirection:{xs:"column", sm:"row"}}}>
                        <Box
                          sx={{
                            flex: { xs: 1, sm: 0.5 },
                            m: 1,
                            minWidth: "10px",
                          }}
                        >
                          <Autocomplete
                            disabled={
                              disableAll === undefined ? false : disableAll
                            }
                            error={
                              state.errorStatus.hsnCode === true ? true : false
                            }
                            disablePortal
                            id="HSN CODE"
                            name="hsnCode"
                            placeholder="HSN Code"
                            disableClearable
                            options={["Add HSN Code", ...filterHSN]}
                            isOptionEqualToValue={(option, value) =>
                              option?.value == value?.value
                            }
                            value={state.hsnCode}
                            onChange={(e, newValue) => {
                              if (newValue == "") {
                                setState((prev) => ({
                                  ...prev,
                                  hsnCode: newValue,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    hsnCode: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    hsnCode: "HSN Code is required",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  hsnCode: newValue,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    hsnCode: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    hsnCode: "",
                                  },
                                }));
                              }
                            }}
                            sx={{
                              ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                              {
                                paddingBottom: "5px",
                              },
                              ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                              {
                                paddingTop: "6px",
                                paddingBottom: "5px",
                                paddingLeft: "6px",
                              },
                            }}
                            size="small"
                            renderOption={(props, option) => (
                              <>
                                {option === "Add HSN Code" ? (
                                  <MenuItem
                                    value={"addHsn"}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.preventDefault();
                                      setOpenHsnModal(true);
                                      setHSNParamsID("");
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      position: "fixed",
                                      top: "0px",
                                      width: "100%",
                                      backgroundColor: grey[50],
                                      "&:hover": {
                                        backgroundColor: grey[200],
                                      },
                                    }}
                                  >
                                    <AddBox
                                      fontSize="small"
                                      sx={{
                                        marginRight: "5px",
                                        color: "primary.main",
                                      }}
                                    />
                                    <ListItemText
                                      sx={{ color: "primary.main" }}
                                      primary={"Add HSN Code"}
                                    />
                                  </MenuItem>
                                ) : (
                                  <li {...props}>{option.label}</li>
                                  // <MenuItem
                                  //   {...props}
                                  //   key={option.value}
                                  //   value={option.value}
                                  // >
                                  //   <ListItemText primary={option.label} />
                                  // </MenuItem>
                                )}
                              </>
                            )}
                            renderInput={(params) => (
                              <TextField
                                onChange={(event) => {
                                  handleSearch(event.target.value);
                                }}
                                sx={{
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                  {
                                    padding: "8.5px 7px",
                                  },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                  {
                                    fontSize: "14px",
                                  },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                  {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "input.border",
                                  },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                  ".css-14qz1ij-MuiListItemText-root": {
                                    margin: "0px",
                                  },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                {...params}
                                label="HSN Code"
                              />
                            )}
                          />
                          {searchValue < 3 &&
                            state.errorStatus.hsnCode !== true ? (
                            <Typography
                              sx={{
                                marginTop: "2px",
                                marginLeft: "10px",
                                marginBottom: "0px",
                                fontSize: "11px",
                                color: "primary.main",
                              }}
                            >
                              Use atleast 3 characters
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                marginTop: "2px",
                                marginLeft: "10px",
                                marginBottom: "0px",
                                fontSize: "11px",
                                color: "danger.main",
                              }}
                            >
                              {state?.errorFields.hsnCode}
                            </Typography>
                          )}
                        </Box>
                        <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                          <TextField
                            disabled={
                              disableAll === undefined ? false : disableAll
                            }
                            error={
                              state.errorStatus.gstrate === true ? true : false
                            }
                            select
                            name="gstrate"
                            label="GST Rate"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={state.gstrate}
                            onChange={(e) => {
                              const name = e.target.name;
                              const value = e.target.value;

                              if (value != "addgstrate") {
                                if (value === "") {
                                  setState((prev) => ({
                                    ...prev,
                                    ["gstrate"]: value,
                                    ["errorStatus"]: {
                                      ...prev.errorStatus,
                                      ["gstrate"]: true,
                                    },
                                    ["errorFields"]: {
                                      ...prev.errorFields,
                                      ["gstrate"]: "GST Rate is required",
                                    },
                                  }));
                                } else {
                                  setState((prev) => ({
                                    ...prev,
                                    ["gstrate"]: value,
                                    ["errorStatus"]: {
                                      ...prev.errorStatus,
                                      ["gstrate"]: false,
                                    },
                                    ["errorFields"]: {
                                      ...prev.errorFields,
                                      ["gstrate"]: "",
                                    },
                                  }));
                                }
                              }
                            }}
                            sx={{
                              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                              {
                                fontSize: "14px",
                              },
                              label: {
                                fontSize: "14px",
                              },
                              ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                                fontSize: "14px",
                              },
                              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                borderColor: "input.border",
                              },
                              ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          >
                            {[
                              { id: 0, rate: "0%" },
                              { id: 5, rate: "5%" },
                              { id: 12, rate: "12%" },
                              { id: 18, rate: "18%" },
                              { id: 28, rate: "28%" },
                            ]?.map((item, ind) => {
                              return (
                                <MenuItem key={item.id} value={`${item.id}`}>
                                  <ListItemText
                                    sx={{ margin: "0px" }}
                                    primary={item.rate}
                                  />
                                </MenuItem>
                              );
                            })}
                            <MenuItem
                              value={"addgstrate"}
                              // onClick={() => setUnitModal(true)}
                              sx={{
                                color: theme?.palette?.TmId.id.toString().includes("9")
                                  ? "black"
                                  : "",
                                backgroundColor: grey[50],
                                "&:hover": {
                                  backgroundColor: grey[200],
                                },
                              }}
                            >
                              <SettingsIcon
                                fontSize="small"
                                sx={{ marginRight: "5px" }}
                              />
                              <ListItemText
                                primary={"Add GST Rate"}
                              />
                            </MenuItem>
                          </TextField>
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.gstrate}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection:{xs:"column", sm:"row"}}}>
                        <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                          <Box
                            sx={{
                              position: "relative",
                              border: "solid 1px",
                              borderColor:
                                state.errorStatus.cessType === true
                                  ? "danger.main"
                                  : "input.border",
                              borderRadius: "4px",
                              padding: "10px 14px",
                              ".css-ahj2mt-MuiTypography-root": {
                                fontSize: "12px",
                                color: "input.font",
                              },
                              ".css-1n70hd2-MuiButtonBase-root-MuiRadio-root": {
                                padding: "0px",
                                margin: "0px 5px",
                              },
                              ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root": {
                                padding: "0px",
                                margin: "0px 5px",
                                color: "input.border",
                              },
                              ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked":
                              {
                                color: "primary.main",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "0.75em",
                                letterSpacing: "0.00938em",
                                position: "absolute",
                                top: "-10px",
                                left: "9px",
                                background: theme?.palette?.TmId.id.toString().includes("9") ? "#1E1E1E" : "#fff",
                                padding: "0px 3px",
                                color:
                                  state.errorStatus.cessType === true
                                    ? "danger.main"
                                    : "input.font",
                              }}
                            >
                              GST compensation Cess Type{" "}
                              <span style={{ color: "#e55353" }}>*</span>
                            </Typography>

                            <RadioGroup
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "row", sm: "row" },
                              }}
                              name="cessType"
                              value={state.cessType}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setState((prev) => ({
                                    ...prev,
                                    cessType: value,

                                    errorStatus: {
                                      ...prev.errorStatus,
                                      cessType: true,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      cessType:
                                        "Please Select GST Compensation  Type",
                                    },
                                  }));
                                } else {
                                  setState((prev) => ({
                                    ...prev,
                                    cessType: value,
                                    errorStatus: {
                                      ...prev.errorStatus,
                                      cessType: false,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      cessType: "",
                                    },
                                  }));
                                }
                              }}
                            >
                              <FormControlLabel
                                disabled={
                                  disableAll === undefined ? false : disableAll
                                }
                                value="Percentage"
                                control={<Radio size="small" disableRipple />}
                                label="Percentage"
                              />
                              <FormControlLabel
                                disabled={
                                  disableAll === undefined ? false : disableAll
                                }
                                value="Amount"
                                control={<Radio size="small" />}
                                label="Amount"
                              />
                            </RadioGroup>
                          </Box>
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state.errorFields.cessType}
                          </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                          <TextField
                            disabled={
                              disableAll === undefined ? false : disableAll
                            }
                            error={state.errorStatus.cess == true ? true : false}
                            label="Cess"
                            name="cess"
                            id="Cess"
                            value={state.cess}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                            size="small"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {state.cessType == "Percentage" ? "%" : "₹"}
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.cess}
                          </Typography>
                        </Box>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}
            </Box>

            <Box
              sx={{
                // padding : "15px",
                // width:'100%',
                display: "flex",
                justifyContent: "space-between",
                // flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              {disableAll == false && (
                <LoadingButton
                  loading={loading}
                  disableRipple={true}
                  onClick={saveChanges}
                  variant="contained"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  Save
                </LoadingButton>
              )}
            </Box>
          </Paper>
        </Fade>
      </Modal>
      <AddPartyModal
        open={openPartyModal}
        setOpen={setOpenPartyModal}
        partyType={partyType}
        partyName={partyName}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarText={setSnakbarText}
        page="AccountModal"
        setNeedDashBoardRender={setNewAccID}
      />

        <AddNewPartyModal
          open={openPartyModal1}
          setOpen={setOpenPartyModal1}
          partyType={
            selelctedGroupId == 7
              ? "supplier"
              : selelctedGroupId == 15
              ? "customer"
              : "Add Party"
          }
          setNewPartyID={setNewPartyID}
          partyParamsID={""}
          Type={"Accounts"}
          newPartyName={newPartyName}
          setNewPartyName={setNewPartyName}
        />
      <AddBankAccount
        open={openBankModal}
        setOpen={setOpenBakModal}
        accountName={accName}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarText={setSnakbarText}
        setWarningSnakbar={setWarningSnakbar}
        setWarningText={setWarningText}
        paymentMethod={
          msg == "Payment"
            ? "PaidTo"
            : msg == "Receipt"
              ? "ReceivedFrom"
              : "InvoiceToAccount"
        }
        itemEntry={itemEntry}
        setState1={setState1}
        msg={msg}
        companyDetails={companyDetails}
        setNewAccID={setNewAccID}
      />
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          setData={setState}
          data={state}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          searchHSNSAC={(value) => searchSAC(value)}
          hsnParamsID={hsnParamsID}
          page={"Invoice"}
        />
      )}
    </Box>
  );
};

export default EditToAccount;
